import {LocalDate, LocalDateTime, LocalTime} from 'js-joda'
import * as R from 'ramda'
import * as Dictionary from '../../../Data/Dictionary'
import * as Nullable from '../../../Data/Nullable'
import * as PrismaManufacturerStatus
    from '../../../Entities/PrismaManufacturerStatus'
import {BpsUser} from '../../../Entities/BpsUser'
import * as PrismaRequestFilterInput from './PrismaRequestFilterInput'
import * as PrismaRequestFilterType from './PrismaRequestFilterType'

export type M =
    | BpsUserFilter
    | CreatedFromFilter
    | CreatedToFilter
    | StatusFilter

interface BpsUserFilter {
    readonly type: 'BpsUserFilter'
    readonly bpsUser: BpsUser
}

interface CreatedFromFilter {
    readonly type: 'CreatedFromFilter'
    readonly createdFrom: LocalDate
}

interface CreatedToFilter {
    readonly type: 'CreatedToFilter'
    readonly createdTo: LocalDate
}

interface StatusFilter {
    readonly type: 'StatusFilter'
    readonly status: PrismaManufacturerStatus.M
}

export function toFilterType(filter: M): PrismaRequestFilterType.M {
    switch (filter.type) {
        case 'BpsUserFilter':
            return 'BpsUser'
        case 'CreatedFromFilter':
            return 'CreatedFrom'
        case 'CreatedToFilter':
            return 'CreatedTo'
        case 'StatusFilter':
            return 'Status'
    }
}

export function label(filter: M): string {
    switch (filter.type) {
        case 'BpsUserFilter':
            return `${filter.bpsUser.lastName}, ${filter.bpsUser.firstName}`
        case 'CreatedFromFilter':
            return `Datum von ${filter.createdFrom}`
        case 'CreatedToFilter':
            return `Datum bis ${filter.createdTo}`
        case 'StatusFilter':
            return PrismaManufacturerStatus.label(filter.status)
    }
}

export function inactiveFilterTypes(filters: M[]): PrismaRequestFilterType.M[] {
    return R.difference(
        PrismaRequestFilterType.all(),
        R.map(toFilterType, filters)
    )
}

export function fromFilterInput(
    filterInput: PrismaRequestFilterInput.M,
): M | null {
    switch (filterInput.type) {
        case 'BpsUserFilterInput':
            return Nullable.map<BpsUser, M>(
                bpsUser => ({type: 'BpsUserFilter', bpsUser}),
                filterInput.selectedBpsUser,
            )
        case 'CreatedFromFilterInput': {
            return Nullable.map<LocalDate, M>(
                createdFrom => ({type: 'CreatedFromFilter', createdFrom}),
                filterInput.value,
            )
        }
        case 'CreatedToFilterInput': {
            return Nullable.map<LocalDate, M>(
                createdTo => ({type: 'CreatedToFilter', createdTo}),
                filterInput.value,
            )
        }
        case 'StatusFilterInput':
            return Nullable.map<PrismaManufacturerStatus.M, M>(
                status => ({type: 'StatusFilter', status}),
                filterInput.value,
            )
    }
}

export function toQueryParameters(filters: M[]): Dictionary.Dictionary<string> {
    return Dictionary.fromList(
        R.map(
            (filter: M): [string, string] => {
                switch (filter.type) {
                    case 'BpsUserFilter':
                        return ['bpsUserId', filter.bpsUser.id.toString()]
                    case 'CreatedFromFilter':
                        return [
                            'createdFrom',
                            LocalDateTime.of(
                                filter.createdFrom,
                                LocalTime.of(0, 0, 0, 0),
                            ).toString()
                        ]
                    case 'CreatedToFilter':
                        return [
                            'createdTo',
                            LocalDateTime.of(
                                filter.createdTo,
                                LocalTime.of(0, 0, 0, 0),
                            ).toString()
                        ]
                    case 'StatusFilter':
                        return [
                            'manufacturerStatus',
                            filter.status,
                        ]
                }
            },
            filters,
        )
    )
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/Components/PrismaRequestFiltering/Model/PrismaRequestFilter.ts